<template>
    <section class="work-mob"  v-if="loaded && ready" >



      <div class="hero" :class="done">
        <media-type  :className="'hero-work-media-type'" :obj="workData.media_mob.media_mob" :dynAlt="'NOSSA Work'"></media-type>



          <div class="main-headline">
            <span class="head-line-orange">{{workData.headline.orange[lang].name}}</span>
            <span class="head-line-white">{{workData.headline.white[lang].name}}</span>
          </div>

        <div class="reel-bt" v-on:click="playVid()" >
          <span v-if="lang === 0">play showreel</span>
          <span v-if="lang === 1">ver showreel</span>

        </div>


        <div class="reel" :class="vis" >
          <video id="vid" >
            <source :src="workData.reel_mob" type="video/mp4">
          </video>

          <div class="controls">
            <img src="/static/images/pause.png" v-on:click="pauseVid()" alt="">
            <img src="/static/images/volume-adjustment.png" v-on:click="muteVid()"  v-if="vol == 1" alt="">
            <img src="/static/images/mute.png" v-on:click="unmuteVid()"  v-if="vol == 0" alt="">

          </div>
        </div>


      </div>


      <div class="group-projects" v-for="(item, index) in tags" :id="getIdTag(item.name[lang].name)">

        <div class="project-tag el-proj"   :class="{'vis' :  offSet.last2 >= index}">  <strong> {{item.name[lang].name}}</strong> </div>



        <div class="item-project el-proj"   v-for="(obj, index2) in projectsFinal"  v-if="item.name[lang].name == obj.proj.tags[0].name[lang].name"  :class="{'vis' :  offSet.last >= obj.count}" v-on:click="goRoute(obj.proj.route)">

          <media-type  :className="'item-project-media-type'" :obj="obj.proj.cover_mob" :objDesk="obj.proj.cover"></media-type>

          <h5 class="item-project-client"> {{obj.proj.client[0].name}}</h5>
          <h1 class="item-project-title"> {{obj.proj.title[lang].name}}</h1>
        </div>

      </div>







      <div class="project-footer">
        <footer-nossa :lang="lang" :isMobile="isMobile"></footer-nossa>
      </div>



    </section>
</template>

<script>




    import {TweenMax} from "gsap/TweenMax";
    import {EVENTBUS, PROJ, WP} from '../main';
    import MediaType from "./Modules/MediaType";
    import ProjCard from "./Modules/ProjCard";
    import FooterNossa from "./FooterNossa";
    import HeroWork from "./Modules/HeroWork";
    import {NavEvents} from "../dataModules/NavEvents";



    export default {


        name: 'work-mob',
      components: {HeroWork, FooterNossa, MediaType},
      props: ['actRoute', 'isMobile', 'lang'],
      watch: {
        '$route' (to, from) {


          this.hasHash(to)
        }
      },
        data() {
            return {
                actScreen: 0,
              workData: [],
              loaded: false,
              ready: false,

              projects: [],
              projectsFinal: [],
              tags: [],

              offSet: {
                  vis: [],
                  vis2: [],
                  tops: [],
                  tops2: [],
                  last: -1,
                  last2: -1,

              },
              done: '',
              navEvt : {},
              vid : {},
              vis: '',
              vol: 1
            }
        },
      head: {
        title: function () {
          const _this = this;
          return {
            inner: 'NOSSA™',   separator: '|',   complement: 'Ideias'
          }
        },


      },
      created() {
        const _this = this;

        //alert(this.$route.path.substring(9, this.$route.path.length))


        WP('work', function (response){

          _this.workData = response[0];


          _this.getProjects();


        });
      },
      mounted() {
        this.ready = true;
        this.init();
        //EVENTBUS.$on('AAA', AAA);
        //EVENTBUS.$emit('AAA', 0);
        $(window).scrollTop(0);
        $('body, html').scrollTop(0);
        EVENTBUS.$on('pauseVid', this.pauseVid);



      },

      destroyed() {

        $( window ).off();
      },

      methods: {

        playVid() {
          this.vid.play();
          this.vis = 'vis';
          this.vid.addEventListener('ended',function(){

            EVENTBUS.$emit('pauseVid');

          },false);

        },

        pauseVid() {

          this.vid.pause();
          this.vis = '';
          this.vid.currentTime = 0;

        },

        muteVid(){
          this.vol = 0;
          this.vid.volume = this.vol;
        },

        unmuteVid(){
          this.vol = 1;
          this.vid.volume = this.vol;
        },




        getProjects(){
          const _this = this;
          WP('projects', function (response){
            _this.projects = response;
            _this.getTags();


          });
        },

        getTags(){

          const _this = this;
          WP('tags', function (response){
            _this.tags = response;
            _this.distributeProjects();

            setTimeout(function () {
              _this.hasHash(_this.$route)
            }, 200);
          });
        },

        hasHash(route){
          console.log(route)
          const _this = this;


          if(route.hash == ''){

          }else{
            let dec =  decodeURI(route.hash)
            let dec2 =  _this.getIdTag(dec)





            setTimeout(function () {
              $('html, body').animate({
                scrollTop: $(dec2).offset().top
              }, 1000);

            }, 200);
          }

        } ,


        distributeProjects(){

          const _this = this;

          let groups  = [];


          _this.tags.forEach(function(obj, index){
            let tagRef = obj.name[0].name;
            groups.push([]);

            _this.projects.forEach(function(proj, index2){
              let projRef = proj.tags[0].name[0].name;
              if(tagRef === projRef){
                groups[index].push(_this.projects[index2]);


              }
            });
          });


          groups.forEach(function(obj, index){

            let refVal1 = obj[0].tags[0].name[0].name;
            obj.forEach(function(obj2, index){
              let refVal2 = obj[0].tags[0].name[0].name;

              if(refVal1 === refVal2) {
                _this.projectsFinal.push({proj : obj2, total: obj.length, order: index});
              }

            });
          });


          _this.projectsFinal.forEach(function(projF, index3){
            projF.count =  index3;
          });




        //  _this.totalScreen = _this.projectsFinal.length;
          _this.loaded = true;
          _this.init();


          /// console.log(_this.projectsFinal);
        },

        init() {
          const _this = this;

          if(this.loaded && this.ready){

           // _this.initScroll();


            $('main').css('pointer-events', 'auto');

            setTimeout(function(){
              _this.done = 'done';

              _this.initScroll();
              _this.vid =  document.getElementById("vid");


            }, 100);


          }
        },


        initScroll(){
          const _this = this;
          console.log(_this.offSet)
          setTimeout(() =>{

            $('.item-project').each(function(i){
              _this.offSet.tops.push($(this).offset().top);
            });

            $('.project-tag').each(function(i){
              _this.offSet.tops2.push($(this).offset().top);
            });

            $( window ).scroll(function(e) {

              _this.scrollEvt()
            });

            $( window ).resize(function() {
              _this.reseizeMe();
            });

            _this.reseizeMe();
            _this.scrollEvt();

          }, 100)
        },

        reseizeMe() {
          this.scrollEvt()
        },

        scrollEvt() {

          const _this = this;

          _this.offSet.act =  $( window ).scrollTop() +  $( window ).height();

          EVENTBUS.$emit('pauseVid');

          $('.item-project').each(function(i){

            if(_this.offSet.act > (_this.offSet.tops[i]  + 20)&&  !_this.offSet.vis[i]) {

              _this.offSet.last = i;
              _this.offSet.vis[i] = true;
            }

          });
          $('.project-tag').each(function(i){

            if(_this.offSet.act > (_this.offSet.tops2[i]  + 20)&&  !_this.offSet.vis2[i]) {

              _this.offSet.last2 = i;
              _this.offSet.vis2[i] = true;
            }

          });



          if(($('.item-project').length - 1) === _this.offSet.last){
            EVENTBUS.$emit('showFooter');
          }




        },

        goRoute(route){


          this.$router.push('project/' + route);

        },

        getIdTag(str){

          var _id = str.replace(/\s/g, "");
          return _id;
        }





      },
    };

</script>


// WEBPACK FOOTER //
// src/components/WorkMob.vue